import { useLoaConsultContext } from "../../../Contexts/LoaConsultContext";
import MultilineText from "../../../Components/MultilineText";
import SearchSelect from "../../../Components/SearchSelect";
import { useAuth } from "../../../Contexts/AuthContext";
import ConformeModal from "../ConformeModal";
import {
  FormControlLabel,
  FormControl,
  FormGroup,
  Checkbox,
} from "@mui/material";
import ErrorComponent from "../../../Components/ErrorComponent";
import { Fragment } from "react";

function RequestForm() {
  const {
    getSpecializations,
    setSpecializations,
    setErrorMessage,
    specializations,
    setErrorField,
    setHospitals,
    setFormData,
    errorField,
    setDoctors,
    hospitals,
    formData,
    doctors,
    isGettingHospitals,
    isGettingDoctors,
    isGettingSpecializations,
    isConformeOpen,
    setIsConformeOpen,
    openField,
    setOpenField,
    getDoctors,
    setIsGettingHospitals,
    setIsGettingDoctors,
    setIsGettingSpecializations,
    allHospitals,
    allDoctors,
    allSpecializations,
    isDropdownLoadFailed,
    reloadDropdown
  } = useLoaConsultContext();

  const { isPhysiciansLoad } = useAuth();

  const handleChange = (e) => {
    let newForm = {
      ...formData,
      [e.target.name]: e.target.value,
    };
    setFormData(newForm);
    setErrorMessage("");
    setErrorField("");
  };

  const handleConformeCheck = (e) => {
    let newForm = {
      ...formData,
      conformeAccepted: e.target.checked,
    };
    setFormData(newForm);
    setErrorMessage("");
    setErrorField("");
  };

  const handleSelectChange = (name, value) => {
    let newForm = {
      ...formData,
      [name]: value,
    };
    if (name === "hospitalName") {
      newForm = {
        ...formData,
        [name]: value,
        specialization: null,
        requestingDoctorName: null,
      };
      setSpecializations([]);
      setDoctors([]);
      if(value){
        getSpecializations(value.providerCode);
      }
    } else if (name === "specialization") {
      newForm = {
        ...formData,
        [name]: value,
        requestingDoctorName: null,
      };
      setDoctors([]);
      if(value){
        getDoctors(value);
      }
    }
    setFormData(newForm);
    setErrorMessage("");
    setErrorField("");
  };

  const renderOption = (props, option) => {
    return (
      <div
        {...props}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <p className="font-bold">{option.providerName}</p>
        <p className="text-sm text-[#60656D]">{option.address}</p>
      </div>
    );
  };

  const renderDoctorOption = (props, option) => {
    return <div {...props}>{option.Physician?.split(":")[0].trim() || ""}</div>;
  };

  const handleOpenConforme = () => {
    setIsConformeOpen(true);
  };

  const filterHospitals = (options, inputValue) => {
    let arr = [];
    if (inputValue) {
      arr = options.filter((item) => {
        let name = item.providerName || "";
        return name.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    return arr;
  };

  const sortHospitals=(input)=>{
    let sorted = [];
    if (input) {
      sorted = allHospitals.sort((a, b) => {
        let aStr = a.providerName || "";
        let bStr = b.providerName || "";

        if (
          aStr.toLowerCase().startsWith(input.toLowerCase()) &&
          bStr.toLowerCase().startsWith(input.toLowerCase())
        ) {
          return aStr.localeCompare(bStr);
        } else if (aStr.toLowerCase().startsWith(input.toLowerCase())) {
          return -1;
        } else if (bStr.toLowerCase().startsWith(input.toLowerCase())) {
          return 1;
        }
        return aStr.toLowerCase().localeCompare(bStr.toLowerCase());
      });
    }
    return sorted;
  }

  const handleHospitalInputChange = (e, v) => {
    setIsGettingHospitals(true);
    const sorted = sortHospitals(v);
    const filtered = filterHospitals(sorted, v);
    const chunkOptions = filtered.slice(0, 100);
    setHospitals(chunkOptions);
    setIsGettingHospitals(false);
  };

  const filterSpecializations = (options, inputValue) => {
    let arr = [];
    if (inputValue) {
      arr = options.filter((item) => {
        return item.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    return arr;
  };

  const sortSpecializations=(input)=>{
    let sorted = [];
    if (input) {
      sorted = allSpecializations.sort((a, b) => {
        if (
          a.toLowerCase().startsWith(input.toLowerCase()) &&
          b.toLowerCase().startsWith(input.toLowerCase())
        ) {
          return a.localeCompare(b);
        } else if (a.toLowerCase().startsWith(input.toLowerCase())) {
          return -1;
        } else if (b.toLowerCase().startsWith(input.toLowerCase())) {
          return 1;
        }
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    }
    return sorted;
  }

  const handleSpecializationInputChange = (e, v) => {
    setIsGettingSpecializations(true);
    const sorted = sortSpecializations(v);
    const filtered = filterSpecializations(sorted, v);
    const chunkOptions = filtered.slice(0, 100);
    setSpecializations(chunkOptions);
    setIsGettingSpecializations(false);
  };

  const filterDoctors = (options, inputValue) => {
    let arr = [];
    if (inputValue) {
      arr = options.filter((item) => {
        let name = item.Physician?.split(":")[0].trim() || "";
        return name.toLowerCase().includes(inputValue.toLowerCase());
      });
    }
    return arr;
  };

  const sortDoctors = (input) => {
    let sorted = [];
    if (input) {
      sorted = allDoctors.sort((a, b) => {
        let aStr = a.Physician?.split(":")[0].trim() || "";
        let bStr = b.Physician?.split(":")[0].trim() || "";

        if (
          aStr.toLowerCase().startsWith(input.toLowerCase()) &&
          bStr.toLowerCase().startsWith(input.toLowerCase())
        ) {
          return aStr.localeCompare(bStr);
        } else if (aStr.toLowerCase().startsWith(input.toLowerCase())) {
          return -1;
        } else if (bStr.toLowerCase().startsWith(input.toLowerCase())) {
          return 1;
        }
        return aStr.toLowerCase().localeCompare(bStr.toLowerCase());
      });
    }
    return sorted;
  };

  const handleDoctorInputChange = (e, v) => {
    setIsGettingDoctors(true);
    const sorted = sortDoctors(v);
    const filtered = filterDoctors(sorted, v);
    const chunkOptions = filtered.slice(0, 100);
    setDoctors(chunkOptions);
    setIsGettingDoctors(false);
  };

  const renderErrorMessage =(hasError, field)=>{
    const messages = {
      "hospitalName": "hospital name",
      "specialization": "specialization",
      "requestingDoctorName": "name of requesting doctor"
    }

    let message = ""
    if(hasError){
      if(field === errorField){
        message = `Oops! It seems like you forgot to enter the ${messages[field]}`
      }else{
        message = `Oops! Enter the ${messages[errorField]} first`
      }
    }
    return message;
  }

  let content = null;
  if (isDropdownLoadFailed) {
    content = (
      <ErrorComponent
        onRetry={reloadDropdown}
        isLoading={isGettingHospitals || isGettingSpecializations}
      />
    );
  } else {
    content = (
      <Fragment>
        <FormControl
          sx={{ mb: 2, width: "100%" }}
          error={errorField === "hospitalName"}
        >
          <p className="font-semibold">Hospital name</p>
          <div className="mt-1">
            <SearchSelect
              options={hospitals}
              open={openField === "hospitalName"}
              value={formData.hospitalName}
              onChange={(v) => handleSelectChange("hospitalName", v)}
              onOpen={() => setOpenField("hospitalName")}
              onClose={() => setOpenField("")}
              renderOption={renderOption}
              onInputChange={handleHospitalInputChange}
              getOptionLabel={(o) => o.providerName}
              isOptionEqualToValue={(o, v) => o.providerCode === v.providerCode}
              noOptionsText="No hospital found"
              loading={isGettingHospitals}
              error={errorField === "hospitalName"}
              helperText={
                errorField === "hospitalName" &&
                "Oops! It seems like you forgot to enter the hospital name"
              }
            />
          </div>
        </FormControl>
        <FormControl
          sx={{ mb: 2, width: "100%" }}
          error={
            ["hospitalName", "specialization"].includes(errorField)
          }
        >
          <p className="font-semibold">Specialization</p>
          <div className="mt-1">
            <SearchSelect
              disabled={!formData.hospitalName}
              options={specializations}
              open={openField === "specialization"}
              value={formData.specialization}
              onChange={(v) => handleSelectChange("specialization", v)}
              onOpen={() => setOpenField("specialization")}
              onClose={() => setOpenField("")}
              onInputChange={handleSpecializationInputChange}
              noOptionsText="No specialization found"
              loading={isGettingSpecializations}
              error={
                ["hospitalName", "specialization"].includes(errorField)
              }
              helperText={
                renderErrorMessage(
                  ["hospitalName", "specialization"].includes(errorField),
                  "specialization"
                )
              }
            />
          </div>
        </FormControl>
        <FormControl
          sx={{ mb: 2, width: "100%" }}
          error={
            ["hospitalName", "specialization", "requestingDoctorName"].includes(errorField)
          }
        >
          <p className="font-semibold">Name of requesting Doctor</p>
          <div className="mt-1">
          <SearchSelect
              disabled={!formData.specialization || isPhysiciansLoad}
              options={doctors}
              open={openField === "requestingDoctorName"}
              value={formData.requestingDoctorName}
              onChange={(v) => handleSelectChange("requestingDoctorName", v)}
              onOpen={() => setOpenField("requestingDoctorName")}
              onClose={() => setOpenField("")}
              renderOption={renderDoctorOption}
              onInputChange={handleDoctorInputChange}
              getOptionLabel={(o) => o.Physician?.split(":")[0].trim() || ""}
              getOptionKey={(o) => o.Provider + o.Physician}
              isOptionEqualToValue={(o, v) => o.Physician === v.Physician}
              noOptionsText="No doctor found"
              loading={isGettingDoctors || isPhysiciansLoad}
              error={
                ["hospitalName", "specialization", "requestingDoctorName"].includes(errorField)
              }
              helperText={
                renderErrorMessage(
                  ["hospitalName", "specialization", "requestingDoctorName"].includes(errorField),
                  "requestingDoctorName"
                )
              }
            />
          </div>
        </FormControl>
        <FormControl sx={{ width: "100%" }}>
          <p className="font-semibold">Chief complaint</p>
          <div className="mt-1">
            <MultilineText
              type="text"
              name="chiefComplaint"
              value={formData.chiefComplaint}
              onChange={handleChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^\x20-\x7FñÑ]+/g, "");
              }}
              error={errorField === "chiefComplaint"}
              helperText={
                errorField === "chiefComplaint" &&
                "Oops! It seems like you forgot to specify the chief complaint"
              }
            />
          </div>
        </FormControl>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.conformeAccepted}
                onChange={handleConformeCheck}
              />
            }
            label={
              <p className="text-sm">
                I confirm that I have read and fully understood the{" "}
                <button
                  onClick={handleOpenConforme}
                  className="text-[#0869cf]"
                >
                  conforme
                </button>{" "}
                therein
              </p>
            }
          />
        </FormGroup>
      </Fragment>
    );
  }

  return (
    <div className="p-4 w-screen sm:w-148">
      <p className="text-[#60656D] mb-4">
        Please complete the form below to request a consultation LOA
      </p>
      {content}
      <ConformeModal
        open={isConformeOpen}
        onClose={() => setIsConformeOpen(false)}
      />
    </div>
  );
}

export default RequestForm;